import { render } from "./changePassword.vue?vue&type=template&id=99c9ba9a&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=99c9ba9a&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c9ba9a"]])

export default __exports__